import { generateUUID } from '@/utils'
import { getStores } from '@/stores'
import { message } from 'antd'
import { MessageContent } from '@/types/message'
import { triggerGotoLoginExpiredEvent } from '@/business/login/help'
import type { AllEvent } from './types'

export const processError = (err: any) => {
  if (err instanceof Error) {
    addTextMsgToChatPanel({
      message_id: generateUUID(),
      content: [
        {
          type: 'block',
          showAvatar: true,
          typing: true,
          is_first: true,
          finished: true,
          value: [
            {
              type: 'text',
              value: '服务器繁忙，请稍后再试',
              display: 'inline'
            }
          ]
        }
      ]
    })
  }
}

function paserContentNode(
  content: any,
  opt?: {
    typing?: boolean
    showAvatar?: boolean
  }
) {
  const { typing = true, showAvatar = false } = opt || {}
  let arr: any = []
  if (content[0].type !== 'block') {
    arr.push({
      showAvatar: showAvatar,
      type: 'block',
      ext_data: null,
      typing: typing,
      styleType: 'normal',
      value: [...content]
    })
  } else {
    arr = content.map(item => {
      return {
        ...item,
        ext_data: item.ext_data || null,
        showAvatar: showAvatar,
        styleType: item?.styleType || item?.style_type || 'normal',
        typing: typing
      }
    })
  }

  return arr
}

export const addStreamTextMsgToChatPanel = (args: {
  message_id: string
  data?: {
    text: string
  }
  update_field: string[]
  is_first?: boolean
  finished?: boolean
  template_id?: string
}) => {
  const { agentV2Store } = getStores()
  const {
    message_id,
    is_first,
    finished,
    data: streamData,
    template_id = '',
    update_field = []
  } = args || {}
  agentV2Store.chatLoadingState.loading = false

  //流式输出的开始
  if (is_first && !finished) {
    agentV2Store.isStreamingOutput = true
    agentV2Store.typing = true
  }

  const renderNodeItem = agentV2Store.renderMsgList.find(item => item.message_id === message_id)
  //如果此时节点还没渲染，直接拼接
  if (!renderNodeItem) {
    const peddingRenderNode = agentV2Store.messagesList.find(item => item.message_id === message_id)
    if (!peddingRenderNode) return
    // 找到 think 模板节点并更新 text
    const node = peddingRenderNode.content[0].value.find(
      (node: any) => node.type === 'template' && node.template_id === template_id
    )

    if (node) {
      if (update_field.length && streamData) {
        update_field.forEach(field => {
          const isArray = Array.isArray(node.value[field])
          if (isArray) {
            node.value[field] = node.value[field].concat(streamData?.[field])
          } else {
            node.value[field] = node.value[field] + streamData?.[field]
          }
        })
      }
      agentV2Store.triggerMessageUpdate(message_id)

      // node.value.text = (node.value.text || '') + text
      // agentV2Store.triggerMessageUpdate(message_id)
    }
    return
  }
  // 找到 think 模板节点并更新 text
  const node = renderNodeItem.content[0].value.find(
    (node: any) => node.type === 'template' && node.template_id === template_id
  )
  if (node) {
    if (update_field.length && streamData) {
      update_field.forEach(field => {
        const isArray = Array.isArray(node.value[field])
        if (isArray) {
          node.value[field] = node.value[field].concat(streamData?.[field])
        } else {
          node.value[field] = node.value[field] + streamData?.[field]
        }
      })
    }
    agentV2Store.triggerMessageUpdate(message_id)
  }

  if (finished) {
    agentV2Store.isStreamingOutput = false
    agentV2Store.chatLoadingState.loading = false
    agentV2Store.typing = false
  }
}

export const addTextMsgToChatPanel = (data: {
  content: any
  message_id: string
  event_type?: string
  role?: 'user' | 'assistant'
  is_first?: boolean
  finished?: boolean
}) => {
  const { agentV2Store } = getStores()
  const { content: rawContent, message_id, is_first, finished, role = 'assistant' } = data || {}
  const { showAvatar } = rawContent?.[0] || {}
  const isImage = data.event_type === 'image'
  const isUser = role === 'user'

  // 只在首条消息时，将内容存储到messageMapping中
  const parsedContent = rawContent?.length
    ? paserContentNode(rawContent, { showAvatar: showAvatar ?? !isImage, typing: !isImage })
    : []

  //表示是完整的一段话
  if (is_first && finished) {
    const msgNode: MessageContent = {
      id: generateUUID(),
      message_id: message_id,
      sender: isUser ? 'user' : 'ai',
      placement: isUser ? 'end' : 'start',
      content: parsedContent
    }
    agentV2Store.messagesList.push(msgNode)
    agentV2Store.typing = true // 设置打字机输出中,不允许发送消息
    agentV2Store.chatLoadingState.loading = false

    return
  }

  //流式输出的开始
  if (is_first) {
    agentV2Store.isStreamingOutput = true
    agentV2Store.chatLoadingState.loading = false
    agentV2Store.messageMapping[message_id] = {
      data: parsedContent,
      renderIndex: -1
    }

    if (parsedContent.length) {
      const msgNode: MessageContent = {
        id: generateUUID(),
        message_id: message_id,
        sender: 'ai',
        placement: 'start',
        content: parsedContent
      }
      agentV2Store.messagesList.push(msgNode)
      agentV2Store.typing = true // 设置打字机输出中,不允许发送消息
    }
  }

  //流式消息的中间段那部分数据
  if (!is_first && !finished) {
    //处理中途推送的image节点
    // if (data.event_type === 'image') {
    //   const _parsedContent = paserContentNode(rawContent, { typing: false })
    //   const msgNode: MessageContent = {
    //     id: generateUUID(),
    //     message_id: message_id,
    //     sender: 'ai',
    //     placement: 'start',
    //     content: _parsedContent,
    //   }
    //   agentV2Store.messagesList.push(msgNode)
    //   agentV2Store.typing = true // 设置打字机输出中,不允许发送消息
    //   agentV2Store.chatLoadingState.loading = false
    //   return
    // }

    const oldMsgNode = agentV2Store.messageMapping?.[message_id]

    if (!oldMsgNode) {
      return
    }
    let index = -1

    if (oldMsgNode?.renderIndex === -1) {
      index = agentV2Store.renderMsgList.findIndex(item => item.message_id === message_id)
      if (index >= 0) agentV2Store.messageMapping[message_id].renderIndex = index
    } else {
      index = oldMsgNode?.renderIndex
    }

    if (oldMsgNode?.data && index !== -1) {
      const renderedContentNode: any = agentV2Store.renderMsgList[index].content[0]
      if (!renderedContentNode?.value?.length) return
      if (!Array.isArray(rawContent?.[0]?.value)) return

      rawContent[0].value.forEach((node: any) => {
        renderedContentNode.value.some((item: any) => {
          if (item.type === node.type && (node.type === 'text' || node.type == 'markdown')) {
            item.value = item.value + node.value
            return true
          }
        })
      })

      agentV2Store.renderMsgList[index].content[0] = renderedContentNode
      // 使用精确更新，只更新当前消息，避免全量重新渲染
      agentV2Store.triggerMessageUpdate(message_id)
    }
    return
  }

  if (finished) {
    // agentV2Store.typing = false // 设置打字机输出中,不允许发送消息
    agentV2Store.chatLoadingState.loading = false
  }
}

const win = window as any

const addTemplateMsgToChatPanel = (data: {
  content: any[]
  message_id: string
  is_first?: boolean
  finished?: boolean
}) => {
  const { agentV2Store } = getStores()
  const { content, message_id } = data || {}

  if (!content.length) return
  const showAvatar = content?.[0]?.showAvatar || false
  const arr: any = paserContentNode(content, {
    showAvatar: showAvatar
  })

  const msgNode: MessageContent = {
    id: generateUUID(),
    message_id: message_id,
    sender: 'ai',
    placement: 'start',
    content: arr
  }
  agentV2Store.messagesList.push(msgNode)
}

win.__agent_utils__ = {
  addTextMsgToChatPanel,
  addTemplateMsgToChatPanel
}

//更新节点状态
const updateNodeData = (args: {
  message_id: string
  template_id: string
  update_field?: string[]
  update_all_field?: boolean
  data: any
}) => {
  const { message_id, template_id, update_field = [], update_all_field = false, data } = args || {}
  const { agentV2Store } = getStores()

  const renderNodeItem = agentV2Store.renderMsgList.find(item => item.message_id === message_id)

  //如果此时节点还没渲染，直接拼接
  if (!renderNodeItem) {
    const peddingRenderNode = agentV2Store.messagesList.find(item => item.message_id === message_id)
    if (!peddingRenderNode) return
    // 找到 think 模板节点并更新 text
    const node = peddingRenderNode.content[0].value.find(
      (node: any) => node.type === 'template' && node.template_id === template_id
    )
    if (node) {
      if (update_all_field && Object.keys(data).length) {
        Object.keys(data).forEach(dataKey => {
          node.value[dataKey] = data?.[dataKey]
        })
      } else {
        //更新所有字段
        if (update_field.length && data) {
          update_field.forEach(field => {
            node.value[field] = data?.[field]
          })
        }
      }
      agentV2Store.triggerMessageUpdate(message_id)
    }
    return
  }

  // 找到 think 模板节点并更新 text
  const node = renderNodeItem.content[0].value.find(
    (node: any) => node.type === 'template' && node.template_id === template_id
  )
  if (node) {
    if (update_all_field && Object.keys(data).length) {
      Object.keys(data).forEach(dataKey => {
        node.value[dataKey] = data?.[dataKey]
      })
    } else {
      if (update_field.length && data) {
        update_field.forEach(field => {
          node.value[field] = data?.[field]
        })
      }
    }

    agentV2Store.triggerMessageUpdate(message_id)
  }
}

export const processMsg = (
  eventData: AllEvent,
  opt: {
    renderToChatPanel?: boolean
    onBiz?: (data: { code: number; message: string; data: any[] }) => void
    onConnect?: () => void
    onDisconnect?: () => void
    onBusinessError?: (data: { code: number; msg: string }) => void
    controller?: AbortController
  }
) => {
  if (!eventData) return
  const { agentV2Store } = getStores()
  agentV2Store.lastEventId = eventData.event_id
  try {
    switch (eventData.event_type) {
      case 'update_node_data':
        updateNodeData({
          message_id: eventData.message_id,
          template_id: eventData.template_id,
          update_field: eventData.update_field,
          data: eventData.data,
          update_all_field: eventData.update_all_field
        })
        break
      case 'stream':
        // TypeScript 自动识别 eventData 为 StreamEvent 类型
        addStreamTextMsgToChatPanel({
          message_id: eventData.message_id,
          update_field: eventData.update_field,
          data: eventData.data,
          is_first: eventData.is_first,
          finished: eventData.finished,
          template_id: eventData.template_id
        })
        break
      case 'biz':
        opt.onBiz?.({
          code: eventData.code || eventData.data?.code || 0,
          data: eventData.data?.data || [],
          message: eventData.message
        })
        break
      case 'loading':
        if (opt.renderToChatPanel) {
          agentV2Store.chatLoadingState.loading = eventData?.content?.[0]?.loading || false
          agentV2Store.chatLoadingState.loadingText =
            eventData?.content?.[0]?.loadingText || '思考中...'
        }
        break
      case 'error':
        agentV2Store.chatLoadingState.loading = false
        opt?.onBusinessError?.({
          code: eventData!.error!.code,
          msg: eventData!.error!.message
        })

        console.error(eventData?.error?.message, eventData)

        if (eventData?.error?.code === 401) {
          message.error('登录已过期，请重新登录')
          opt?.controller?.abort?.()
          triggerGotoLoginExpiredEvent()
          return
        }

        if (eventData?.error?.code !== 401 && eventData?.error?.message) {
          message.error(eventData.error.message)
        }

        break
      //关闭连接
      case 'finished':
        opt?.controller?.abort?.()
        opt.onDisconnect?.()
        agentV2Store.typing = false
        break
      //连接成功
      case 'connected':
        opt.onConnect?.()
        // agentV2Store.chatLoadingState.loading = false
        break
      case 'markdown':
        if (eventData?.finished) {
          agentV2Store.isStreamingOutput = false // 流式输出完成后,关闭流式输出标记
        }
        break
      //文本消息
      case 'text':
      case 'link':
      case 'image':
      case 'video':
        if (opt.renderToChatPanel) {
          addTextMsgToChatPanel({
            event_type: eventData.event_type,
            message_id: eventData.message_id,
            content: eventData.content,
            role: eventData?.role || 'assistant',
            is_first: eventData.is_first,
            finished: eventData.finished
          })
        }
        break
      //空字符串类型
      // case '':
      //   if (opt.renderToChatPanel) {
      //     addTextMsgToChatPanel({
      //       event_type: data.event_type,
      //       message_id: data.message_id,
      //       content: [],
      //       is_first: data.is_first,
      //       finished: data.finished
      //     })
      //   }
      //   break
      //意图消息
      case 'intention':
        agentV2Store.chatLoadingState.loading = false
        if (opt.renderToChatPanel && eventData?.content?.length) {
          addTemplateMsgToChatPanel({
            message_id: eventData.message_id,
            content: eventData.content,
            is_first: eventData.is_first,
            finished: eventData.finished
          })
        }
        break
    }
  } catch (error) {
    console.error('processMsg error', error)
  }
}
